<template>
    <CustomerNote/>
</template>
<script>
import CustomerNote from 'operations/customer/customerNote.vue'
export default {
    components:{
        CustomerNote
    }
}
</script>